// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { BusinessPhonesResponse } from './business-phones-response';

/** See com.rev360.pms.api.controller.admin.solutions.revdirect.PracticeLocationValidDirectMessageResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeLocationValidDirectMessageResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	address1!: string | null;

	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfProperty({ designType: BusinessPhonesResponse })
	phoneNumbers!: BusinessPhonesResponse | null;

	@GandalfProperty({ designType: String })
	postalCode!: string | null;

	@GandalfProperty({ designType: String })
	stateProvince!: string | null;

}
